import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button, IconButton } from "@mui/material";
import { GoSignOut } from "react-icons/go";
import { CiLogin } from "react-icons/ci";
import { loginRequest } from "./authConfig";
import { GetVoidUserData, useCasUserContext } from "../../services/casUserContext";

const AuthButtons: React.FC = () => {
    const { instance, accounts } = useMsal();
    const casUserContext = useCasUserContext();

    const handleLogin = () => {
        instance.loginRedirect(loginRequest);
    };

    const handleLogout = () => {
        // 1️⃣ Determinar la cuenta activa correctamente
        const activeAccount = instance.getActiveAccount() || (accounts.length > 0 ? accounts[0] : null);
        if (activeAccount) {
            instance.setActiveAccount(activeAccount);
        }
        // 2️⃣ Limpiar tu contexto local
        casUserContext.setUser(false);
        casUserContext.setUserData(GetVoidUserData());
        // 3️⃣ Cerrar sesión en MSAL con la cuenta activa
        instance.logoutRedirect({
            account: activeAccount,        // importante para que MSAL cierre la sesión correcta
            postLogoutRedirectUri: "/inicio",
        });
    };

    return (
        <>
            {accounts.length > 0 ? (
                <IconButton color="default" style={{ color: '#243165' }} onClick={handleLogout}>
                    <GoSignOut />
                </IconButton>
            ) : (
                <Button variant="contained" sx={{ backgroundColor: '#243165' }} onClick={handleLogin} endIcon={<CiLogin />}>
                    Iniciar Sesión
                </Button>
            )}
        </>
    );
};

export default AuthButtons;
